import { render } from "./AyudaAnteAten.vue?vue&type=template&id=49ab452e&scoped=true"
import script from "./AyudaAnteAten.vue?vue&type=script&lang=js"
export * from "./AyudaAnteAten.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=49ab452e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ab452e"]])

export default __exports__